import type { ReactNode, RefObject } from 'react';

import type { HeaderProps } from '@/components/layout/header/Header.types';
import type { SiteNavZonesView } from '@/components/site-page/SitePage.types';

/** The desktop breakpoint, shared with the legacy Header and the HEADER block. */
export const SITE_HEADER_DESKTOP_QUERY = '(min-width: 768px)';
/** Below this width (768-1023 px) CENTER items shed their labels except the first. */
export const SITE_HEADER_WIDE_QUERY = '(min-width: 1024px)';
/** Hover intent delay before a group opens. */
export const HOVER_OPEN_DELAY_MS = 150;

export interface SiteHeaderProps {
  logo: ReactNode;
  logoHref?: string;
  /** Same shape the legacy Header takes. */
  user?: HeaderProps['user'];
  onAvatarClick?: () => void;
  avatarRef?: RefObject<HTMLButtonElement | null>;
  isMenuOpen?: boolean;
  activeSessionIndicator?: HeaderProps['activeSessionIndicator'];
  activeSessionsPopup?: HeaderProps['activeSessionsPopup'];
  /** Audience-filtered, action-resolved items per zone. */
  zones: SiteNavZonesView;
  showLogin: boolean;
  loginHref: string;
  /** An active or upcoming session: the CENTER zone gives way to the session chip. */
  hasLiveSession: boolean;
  /** Logo-only bar while the navigation loads. */
  isLoading?: boolean;
  /**
   * Render nothing below the desktop breakpoint (the (app) layout's mobile-headerless routes,
   * whose pages draw their own phone title bar). At 768 px and up the bar renders as usual.
   */
  hideOnPhone?: boolean;
  /**
   * Positioning only: `sticky`, `top-*`, `z-*`, `flex-none`. Never a display or layout utility
   * (`hidden`, `flex`, `grid`, `block`, with or without a breakpoint): it is merged into each root
   * with tailwind-merge, which drops the root's own `grid` / `flex` on a conflict (PB-9032 R1-F1).
   * Use `hideOnPhone` to hide the bar on phones.
   */
  className?: string;
}

/** How a dropdown panel was opened: decides whether hover may close it and where focus goes. */
export type OpenBy = 'hover' | 'click' | 'key';
